/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Why_2_SrcInputs */

const en_cp_why_2_src = /** @type {(inputs: Cp_Why_2_SrcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`412 students over 3 semesters (Zhu et al., 2026): LLM-assisted score gains vanished in closed-book exams → process-oriented assessment.`)
};

const id_cp_why_2_src = /** @type {(inputs: Cp_Why_2_SrcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studi 412 mahasiswa, 3 semester (Zhu dkk., 2026): keunggulan skor berbantuan LLM lenyap di ujian tertutup → penilaian berorientasi proses.`)
};

/**
* | output |
* | --- |
* | "412 students over 3 semesters (Zhu et al., 2026): LLM-assisted score gains vanished in closed-book exams → process-oriented assessment." |
*
* @param {Cp_Why_2_SrcInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_why_2_src = /** @type {((inputs?: Cp_Why_2_SrcInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Why_2_SrcInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_why_2_src(inputs)
	return en_cp_why_2_src(inputs)
});